import React, { useEffect, Suspense, lazy } from 'react';
import { Hero } from './components/Hero';
import { initMetaPixel } from './utils/metaPixel';
// Below-the-fold sections are code-split so the initial load only ships/renders
// the Hero. Each chunk is fetched on demand, dramatically lowering the JS that
// must be parsed and executed before the page becomes interactive.
const StatsBar = lazy(() => import('./components/StatsBar').then(m => ({
  default: m.StatsBar
})));
const SocialProof = lazy(() => import('./components/SocialProof').then(m => ({
  default: m.SocialProof
})));
const PainSection = lazy(() => import('./components/PainSection').then(m => ({
  default: m.PainSection
})));
const ProductHero = lazy(() => import('./components/ProductHero').then(m => ({
  default: m.ProductHero
})));
const TomosGrid = lazy(() => import('./components/TomosGrid').then(m => ({
  default: m.TomosGrid
})));
const BonosSection = lazy(() => import('./components/BonosSection').then(m => ({
  default: m.BonosSection
})));
const Pricing = lazy(() => import('./components/Pricing').then(m => ({
  default: m.Pricing
})));
const Comparison = lazy(() => import('./components/Comparison').then(m => ({
  default: m.Comparison
})));
const ExtendedTestimonials = lazy(() => import('./components/ExtendedTestimonials').then(m => ({
  default: m.ExtendedTestimonials
})));
const Guarantee = lazy(() => import('./components/Guarantee').then(m => ({
  default: m.Guarantee
})));
const FAQ = lazy(() => import('./components/FAQ').then(m => ({
  default: m.FAQ
})));
const FinalCTA = lazy(() => import('./components/FinalCTA').then(m => ({
  default: m.FinalCTA
})));
const Footer = lazy(() => import('./components/Footer').then(m => ({
  default: m.Footer
})));
const PurchasePopup = lazy(() => import('./components/PurchasePopup').then(m => ({
  default: m.PurchasePopup
})));
// Lightweight placeholder that reserves vertical space to minimise layout shift
// while a lazy section streams in.
function SectionFallback() {
  return <div className="w-full min-h-[40vh]" aria-hidden="true" data-id="element-0" data-mp="3uc9j1w993mja" />;
}
export function App() {
  useEffect(() => {
    // Initialises the Meta Pixel and sends exactly one PageView per page load.
    initMetaPixel();
  }, []);
  return <div className="min-h-screen w-full bg-ink font-sans text-white selection:bg-gold selection:text-ink" data-id="element-1" data-mp="83qhbf77ta66">
      <main data-id="element-2" data-mp="3bmbehq4nwbke">
        <Hero data-id="element-3" data-mp="3bmjrrj4p5iw4" />
        <Suspense fallback={<SectionFallback data-id="element-5" data-mp="3bnmfji6q357t" />} data-id="element-4" data-mp="3bn2zk70muqwf">
          <StatsBar data-id="element-6" data-mp="3bk720jsp648i" />
          <SocialProof data-id="element-7" data-mp="3qb7lrkyw9kjy" />
          <PainSection data-id="element-8" data-mp="3qbfvj3zq09qx" />
          <ProductHero data-id="element-9" data-mp="3qcqzp4x2vjik" />
          <TomosGrid data-id="element-10" data-mp="3qdajkr6aghz8" />
          <BonosSection data-id="element-11" data-mp="3lkr5lt3ovktw" />
          <Pricing data-id="element-12" data-mp="3lk7q0j1ih8j1" />
          <Comparison data-id="element-13" data-mp="3liwjibgolmo8" />
          <ExtendedTestimonials data-id="element-14" data-mp="3lieg8uvlq86t" />
          <Guarantee data-id="element-15" data-mp="2xudb7vxmt9w5" />
          <FAQ data-id="element-16" data-mp="2xtv7ke8n3te7" />
          <FinalCTA data-id="element-17" data-mp="2xtbyln0ywfcb" />
        </Suspense>
      </main>
      <Suspense fallback={null} data-id="element-18" data-mp="2sw1zffns0pba">
        <Footer data-id="element-19" data-mp="2sv0pjeihy8v5" />
        <PurchasePopup data-id="element-20" data-mp="2svaecyrt29z9" />
      </Suspense>
    </div>;
}